import type {
  CollectionDTO,
  CollectionCreateInput,
  CollectionUpdateInput,
} from "@/modules/collections/domain/contracts";
import type { OffsetPageDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";

export type { CollectionDTO };

export const collectionsApi = {
  async list(query: OffsetPageQueryDTO): Promise<OffsetPageDTO<CollectionDTO>> {
    const url = new URL(`${config.apiUrl}/catalog/collections`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<OffsetPageDTO<CollectionDTO>>(url.toString());
  },
  async get(id: string): Promise<CollectionDTO> {
    return fetcher.get<CollectionDTO>(
      `${config.apiUrl}/catalog/collections/${id}`
    );
  },
  async create(input: CollectionCreateInput): Promise<CollectionDTO> {
    return fetcher.post<CollectionDTO>(
      `${config.apiUrl}/catalog/collections`,
      input
    );
  },
  async update(
    id: string,
    input: CollectionUpdateInput
  ): Promise<CollectionDTO> {
    return fetcher.put<CollectionDTO>(
      `${config.apiUrl}/catalog/collections/${id}`,
      input
    );
  },
  async remove(id: string): Promise<{ ok: boolean }> {
    return fetcher.delete<{ ok: boolean }>(
      `${config.apiUrl}/catalog/collections/${id}`
    );
  },
};
